
import { Components } from "appworks/components/components";
import { AbstractMatrixComponent } from "slotworks/components/matrix/abstract-matrix-component";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";

export function SkipSpinCommand(spinRecord: SpinRecord) {
    Components.get(AbstractMatrixComponent).skipTransition(spinRecord);
}
